import { useState, useEffect } from 'react'
import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import { staffApi } from '../../../../api/staff'
import type { AuthSession } from '../../../../types/plans'
import type { ConstructorPlan } from '../constructorTypes'

export function PlanNotePanel({
  plan,
  bootstrap,
  session,
  onReload,
}: {
  plan: ConstructorPlan
  bootstrap: TenantBootstrapModel
  session: AuthSession
  onReload: () => void
}) {
  const [noteVal, setNoteVal] = useState(plan.note ?? '')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setNoteVal(plan.note ?? '')
  }, [plan.note])

  async function handleSave() {
    setSaving(true)
    try {
      await staffApi.updateConstructorPlan(bootstrap, session, plan.id, { note: noteVal.trim() || null })
      onReload()
    } catch {
      // ignore
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-slate-800">Комментарий к плану</h3>
      <p className="mt-1 text-[11px] text-slate-500">
        Отображается пациенту на публичной странице под заголовком плана, если заполнен.
      </p>
      <textarea
        rows={3}
        className="mt-3 w-full resize-none rounded border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-400"
        value={noteVal}
        placeholder="Необязательный комментарий к плану..."
        disabled={saving}
        onChange={(e) => setNoteVal(e.target.value)}
      />
      <button
        type="button"
        className="mt-2 rounded bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700 disabled:opacity-60"
        onClick={() => void handleSave()}
        disabled={saving}
      >
        {saving ? 'Сохранение...' : 'Сохранить комментарий'}
      </button>
    </div>
  )
}
